export class GcpSecretManagerRefInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "resourceName",
            "baseName": "resourceName",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GcpSecretManagerRefInput.attributeTypeMap;
    }
    constructor() {
    }
}
